<template>
  <v-container>
    <v-layout row>
      <v-flex class="row top" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex md12 lg12 xs12 sm12>
        <h3 class="pull">Lista de comunicados</h3>
      </v-flex>
    </v-layout>
    <br/>
    <div class="row bot">
      <div class="col-md-10 col-sm-11 col-xs-12 col-lg-10">
        <v-card v-for="(anuncio,index) in anuncios" :key="index">
          <v-layout row>
            <v-flex md10 lg10 xs8 sm8>
              <h4 class="pull" for="sel1">{{anuncio.titulo}}</h4>
            </v-flex>
            <v-flex md2 lg2 xs2 sm2>
              <v-btn @click="downloadFile(anuncio)" color="warning" small fab dark>
                <v-icon>info</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row></v-layout>
        </v-card>
      </div>
    </div>

    <v-layout>
      <v-dialog v-model="pdfShow" class="dialog">
        <template v-slot:activator="{ on }"></template>
        <v-layout style="  padding-top: 50px!important;">
          <v-btn @click="pdfShow =! pdfShow" small color="red" dark>
            <v-icon dark>close</v-icon>
          </v-btn>
        </v-layout>
        <pdf :src="thispdf" class="pdf"></pdf>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import img1 from "../../assets/Captura.png";

export default {
  components: {
    pdf
  },
  data() {
    return {
      img1: img1,
      pdfShow: true,
      currentPage: 0,
      pageCount: 0,
      anuncios: "",
      anuncio: "",
      thispdf: "",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  created() {
    axios
      .get(process.env.ROOT_API + "/anuncio/getAll", this.auth)
      .then(response => {
        //console.log(response.data);
        this.anuncios = response.data;
      })
      .catch(error => console.error)
      .then(response => {
        this.downloadFile(this.anuncios[0]);
      });
  },

  methods: {
    downloadFile(anuncio) {
      this.pdfShow = true;
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(anuncio.path);
      var nameFile = anuncio.titulo;
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      //console.log(url);
      this.thispdf = url;
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    }
  }
};
</script>

<style scoped>
.v-card {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
}

.v-card2 {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
  width: 90% !important;
}

.dialog {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  width: 200px !important;
}

.pdf {
  width: 50% !important;
  height: 50% !important;
}

.top {
  margin-top: 50px;
}

.bot {
  margin-bottom: 50px;
}

.primary--text {
  color: #ec6a12 !important;
  caret-color: #ec6a12 !important;
}

.v-text-field .v-label--active {
  color: #ec6a12 !important;
}

.v-btn--floating.v-btn--small {
  height: 35px !important;
  width: 35px !important;
  margin-top: 15px !important;
}

.pull {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/Anuncios.vue